import React, { useMemo, useCallback } from 'react';
import {
  Slate,
  Editable,
  withReact,
  useSlateStatic,
  useReadOnly,
  ReactEditor
} from 'slate-react';
import {
  Editor,
  Transforms,
  Range,
  Point,
  createEditor,
  Element as SlateElement
} from 'slate';
import { css } from '@emotion/css';
import { withHistory } from 'slate-history';
import styles from './ac.module.scss';
import { KoCheckBox } from 'packages/checkbox';
const initial = [
  {
    type: 'check-list-item',
    checked: false,
    children: [{ text: '' }]
  }
];
const KoChecklist = (props) => {
  const {form, name , initialValue=initial} = props;
  const renderElement = useCallback(props => <Element {...props} />, []);
  const editor = useMemo(
    () => withChecklists(withHistory(withReact(createEditor()))),
    []
  );

  const onChange = (value) => {
    if(form){
      let data = form?.getFieldsValue();
      data[name] = value;
      form?.setFieldsValue({...data});
    }
    
  };

  return (
    <Slate editor={editor} initialValue={initialValue ? initialValue : initial} onChange={onChange}>
      <div className={styles.card}>
        <div className={styles.wrapper}>
          <Editable
            className={styles.editableWrapper}
            renderElement={renderElement}
            spellCheck
            autoFocus
          />
        </div>
      </div>
    </Slate>
  );
};
const withChecklists = editor => {
  const { deleteBackward } = editor;
  editor.deleteBackward = (...args) => {
    const { selection } = editor;
    if (selection && Range.isCollapsed(selection)) {
      const [match] = Editor.nodes(editor, {
        match: n =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === 'check-list-item'
      });
      if (match) {
        const [, path] = match;
        const start = Editor.start(editor, path);
        if (Point.equals(selection.anchor, start)) {
          const newProperties = {
            type: 'paragraph'
          };
          Transforms.setNodes(editor, newProperties, {
            match: n =>
              !Editor.isEditor(n) &&
              SlateElement.isElement(n) &&
              n.type === 'check-list-item'
          });
          return;
        }
      }
    }
    deleteBackward(...args);
  };
  return editor;
};
const Element = props => {
  return <CheckListItemElement {...props} />;
};
const CheckListItemElement = ({ attributes, children, element }) => {
  const editor = useSlateStatic();
  const readOnly = useReadOnly();
  const { checked } = element;
  return (
    <div
      {...attributes}
      className={css`
        display: flex;
        flex-direction: row;
        align-items: center;

        & + & {
          margin-top: 0;
        }
      `}
    >
      <span
        contentEditable={false}
        className={css`
          margin-right: 0.75em;
        `}
      >
        <KoCheckBox checked={checked}  onChange={event => {
          const path = ReactEditor.findPath(editor, element);
          const newProperties = {
            checked: event.target.checked
          };
          Transforms.setNodes(editor, newProperties, { at: path });
        }} />
      </span>
      <span
        contentEditable={!readOnly}
        suppressContentEditableWarning
        className={css`
          flex: 1;
          opacity: ${checked ? 0.666 : 1};
          color: ${!checked ? 'inherit' : 'var(--palette-primary-dark)'};
          &:focus {
            outline: none;
          }
        `}
      >
        {children}
      </span>
    </div>
  );
};
export default KoChecklist;